import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../models/user';
import { UsersService } from '../services/users-service/users.service';
import { AuthService } from '../services/auth-service/auth.service';

@Injectable()
export class UserResolver implements Resolve<User> {

    constructor(private userService: UsersService, private authService: AuthService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> | Promise<User> | User | any {
        if ( this.authService.isLoggedIn()) {
            return this.userService.getUserMe();
        }
        console.log('USERRESOLVER FALSE!');
    }
}